import { render, staticRenderFns } from "./BannerAdd.vue?vue&type=template&id=5782bf09"
import script from "./BannerAdd.vue?vue&type=script&lang=js"
export * from "./BannerAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports